import { IActivity, IBloomer, IMission, IPricing, ISociety } from './types.shared';

export interface IInvoiceContact {
  firstname: string;
  lastname: string;
  email: string;
  nameJob?: string;
}

export enum IInvoiceItemUnit {
  day = 'day',
  unit = 'unit',
}

export interface IInvoiceItem {
  reference: string;
  label: string;
  quantity: number;
  unitAmountWithoutTaxe: number;
  unitPurchaseAmountWithoutTaxe: number;
  unit: IInvoiceItemUnit;
  vatRate: 0 | 5.5 | 10 | 20;
  description: string;
  discountPercent?: number;
}
export interface IInvoice {
  invoiceDate: Date;
  paymentDate: Date;
  title: string;
  currencyISO4217: string;
  specialMention?: string;
  internalReference: string;
  externalId?: string;
  langage: 'fr_FR' | 'en_GB';
  type: 'FREE' | 'CDI';
  subtype: 'IT' | 'RPO' | 'People';
  orderNumber?: string;
  draft: boolean;
  customerInfos: {
    customerName: string;
    siret: string;
    billingAddressName: string;
    billingAddressPart1: string;
    billingAddressPart2?: string;
    billingPostalCode: string;
    billingCity: string;
    billingCountryCodeAlpha2: string;
    deliveryAddressName: string;
    deliveryAddressPart1: string;
    deliveryAddressPart2?: string;
    deliveryPostalCode: string;
    deliveryCity: string;
    deliveryCountryCodeAlpha2: string;
    recipientName: string;
    vatNumber?: string;
    paymentConditions: '0' | '15' | '30' | '45' | '60' | 'custom';
    billingContacts: IInvoiceContact[];
    operationalContacts: IInvoiceContact[];
    phone?: string;
    internalId: string;
    externalId?: string;
  };
  items: IInvoiceItem[];
}

export interface ISupplierInvoiceSupplierInfos {
  supplierName: string;
  siret: string;
  billingAddressName: string;
  billingAddressPart1: string;
  billingAddressPart2?: string;
  billingPostalCode: string;
  billingCity: string;
  billingCountryCodeAlpha2: string;
  vatNumber?: string;
  paymentConditions: '0' | '15' | '30' | '45' | '60' | 'custom';
  billingContacts: IInvoiceContact[];
  phone?: string;
  internalId: string;
  externalId?: string;
  iban?: string;
}

export interface ISupplierInvoice {
  invoiceDate: Date;
  paymentDate: Date;
  currencyISO4217: string;
  internalReference: string;
  suplierInvoiceNumber?: string;
  externalId?: string;
  langage: 'fr_FR' | 'en_GB';
  subtype: 'IT' | 'RPO' | 'People';
  fileB64Encoded: string;
  draft: boolean;
  supplierInfos: ISupplierInvoiceSupplierInfos;
  items: {
    label: string;
    quantity: number;
    unitAmountWithoutTaxe: number;
    vatRate: 0 | 5.5 | 10 | 20;
    planItemNumber?: string;
  }[];
}

export interface IInvoicePortSocietyAdress {
  name?: string;
  part1?: string;
  part2?: string;
  part3?: string;
  part4?: string;
  zip?: string;
  town?: string;
  countrycode?: string;
  id?: string;
}

export interface IInvoicePortSociety extends ISociety {
  address: IInvoicePortSocietyAdress;
}

export interface IInvoicePortMission extends Omit<IMission, 'bloomer' | 'pricing' | 'activity'> {
  name?: string;
  bloomer: IBloomer;
  pricing: IPricing;
  activity: IActivity;
}

export type SupplierPaymentInfo = {
  supplierEmail: string;
  supplierName: string;
  invoiceAmountFormatted: string;
  invoicePaidAmountFormatted: string;
  invoiceDueAmountFormatted: string;
  invoiceExternalRef: string;
};

export type InvoiceComplianceItem<T> = {
  expected: T;
  founded?: T;
  label: 'invoiceDate' | 'invoiceNumber' | 'totalWithTaxes';
  state: InvoiceComplianceState;
};

export enum InvoiceComplianceState {
  compliant = 'compliant',
  confidence = 'confidence',
  notSure = 'notSure',
  failed = 'failed',
}

export type InvoiceCompliance = Array<
  InvoiceComplianceItem<string> | InvoiceComplianceItem<number> | InvoiceComplianceItem<Date>
>;

export type CreateActivitySupplierInvoiceReturn = {
  externalSupplierInvoiceId: string;
  externalURL: string;
  InvoiceCompliance: InvoiceCompliance;
};

export type CreateBillingCustomerInvoiceReturn = {
  externalCustomerInvoiceId: string;
  externalURL: string;
};

export type CreateActivityCustomerInvoiceReturn = {
  externalCustomerInvoiceId: string;
  externalCustomerInvoiceMarkupId?: string;
  externalURL: string;
};
